<template>
  <iRow vertical-align="middle">
    <AvatarImage :src="entity?.avatarUrl ?? ''" size="75px" />
    <iButton @click="validateClick">
      Change Picture
    </iButton>
  </iRow>
</template>

<script>
// `~/stores/user-store` lives outside the editor directory tree.
// Canvas preview shows the avatar mock + a button placeholder; real
// upload happens on the FanWeb side.
import { UserSettingsPageElementMixin } from "%/dynamic-component-editor/standard-pages/user-settings-page/user-settings-page-element-mixin";
import AvatarImage from "%/dynamic-component-editor/components/AvatarImage.vue";

export default {
  name: "AvatarUpload",
  components: {
    AvatarImage,
  },
  mixins: [UserSettingsPageElementMixin],
  elementPanelSettings: {
    displayName: "Avatar Upload Field",
    displayIcon: "document",
    elementGroup: "userSettingsElements",
    elementType: "element",
  },
  methods: {
    validateClick(event) {
      if (this.editMode) {
        event.stopPropagation();
      }
    },
  },
};
</script>
